import axios from 'axios'
import jsSHA from 'jssha'
import Utils from '../utils/utils'
import CONST from '../utils/const'
import moment from 'moment'

export async function getTrafficCCTVs(condition = {}) {
    let response = {}
    const access_token = getAuthorizationHeader()
    const date = moment().add(-1, 'days').format('YYYY-MM-DD')
    try {
        response = await axios.get(`https://tdx.transportdata.tw/api/basic/v2/Road/Traffic/CCTV/Highway?%24filter=roadName%20eq%20%27%E5%8F%B011%E7%B7%9A%27&%24count=true&%24format=JSON`, {
            // https://tdx.transportdata.tw/api/basic/v2/Road/Traffic/CCTV/Highway?%24filter=roadName%20eq%20%27%E5%8F%B011%E7%B7%9A%27&%24top=1000&%24count=true&%24format=JSON
            // $filter: roadName eq '台11線'
            headers: {
                "authorization": "Bearer " + access_token,                
            },       
        })

    } catch (err) {
        console.error('getTrafficCCTV: ', err)
        return null
    }

    return handleCCTVs(response)
}

function handleCCTVs(response) {
    const result = []

    if(Utils.isEmptyObject(response) || Utils.isEmptyObject(response.data) || Utils.isEmptyObject(response.data.CCTVs)) {
        return result
    }
    
    const cctvs = response.data.CCTVs
    for (let i = 0; i < cctvs.length; i++) {
        const cctv = cctvs[i]
        const target = {}
        target[CONST.TRAFFIC_CCTV_KEY.NAME] = cctv.RoadName + cctv.LocationMile
        target[CONST.TRAFFIC_CCTV_KEY.CCTVID] = cctv.CCTVID
        target[CONST.TRAFFIC_CCTV_KEY.CENTER] = { lat: cctv.PositionLat, lng: cctv.PositionLon }
        target[CONST.TRAFFIC_CCTV_KEY.URL] = cctv.VideoStreamURL
        target[CONST.TRAFFIC_CCTV_KEY.ID] = cctv.CCTVID
        target[CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.TRFFIC
        result.push(target)
    }
    return result
}

function getAuthorizationHeader() {   
    // https://github.com/tdxmotc/SampleCode 範例
    const parameter = {
        grant_type:"client_credentials",
        client_id: "judy-ecnsa-b98385b0-e907-4a87",
        client_secret: "e243420d-1788-4f56-bd86-71d07b91d2b6"
    };
    
    let access_token = ''
    const auth_url = "https://tdx.transportdata.tw/auth/realms/TDXConnect/protocol/openid-connect/token";
        
    $.ajax({
        type: "POST",
        url: auth_url,
        crossDomain:true,
        dataType:'JSON',                
        data: parameter,
        async: false,       
        success: function(data){            
            access_token = data.access_token                       
        },
        error: function (xhr, textStatus, thrownError) {
            
        }
    });
    
    return access_token;
}